export class HeaderCountsModel {
    goldInwardCount?: number = 0;
    diamondInwardCount?: number = 0;
    interStoreInwardCount?: number = 0;
    goldSnmccInwardCount?: number = 0;
    diamondSnmccInwardCount?: number = 0;
    repairInwardCount?: number = 0;
    notificationCount?: number = 0;
    diamondConsignmentInwardCount?: number = 0;
    goldConsignmentInwardCount?: number = 0;
}